import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {PlatformParamsProps} from "../context/UserContext";


export const generatePlatformToken = async (ott: string, platform: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'generatePlatformToken',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            ott, platform
        },
    });
}